<div *ngIf="!file">
    <app-loading-message></app-loading-message>
</div>
<div *ngIf="file">
    <a
        class="pill"
        [ngbPopover]="popContent"
        popoverTitle="{{ file.title }}">
        <i class="las la-file"></i>
        <ng-template #popContent>
            <span>
                {{ file | json }}
            </span>
        </ng-template>

        {{ file.title }}
    </a>
</div>
